import { connect } from 'react-redux'
import { setLanguage } from '@/store/actions/appSettings'
import { beginSetPassword } from '@/store/actions/user/setPassword'
import { beginRestoreAccount } from '@/store/actions/user/restoration'
import { loginUser } from '@/store/actions/user/authorization'

import { getLanguageState } from '@/store/selectors/appSettings'
import {
  getUserSetPasswordError,
  getUserRestorationError,
  getUserAuthorizationError,
  getUserMockLoginError,
  getUserSetPasswordStatus,
} from '@/store/selectors/user'


import SignUp from './component'

const mapStateToProps = (state) => ({
  language: getLanguageState(state),
  mockLoginError: getUserMockLoginError(state),
  loginError: getUserAuthorizationError(state),
  resetError: getUserRestorationError(state),
  setPasswordError: getUserSetPasswordError(state),
  setPasswordStatus: getUserSetPasswordStatus(state),
})
const mapDispatchToProps = (dispatch) => ({
  onSetLanguage: (language) => dispatch(setLanguage(language)),
  onLoginUser: (...data) => dispatch(loginUser(data)),
  onSetUsersPassword: (...data) => dispatch(beginSetPassword(data)),
  onRestoreUser: (...data) => dispatch(beginRestoreAccount(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)
